import { NumberCell } from 'components/DataTableTest'

export const columns_inventory = (t) => [{
	caption: t('common.fields.code'),
	dataField: 'code'
}, {
	caption: t('common.fields.name'),
	dataField: 'name'
}, {
	caption: t('product_section.fields.sales_unit'),
	dataField: 'unitName'
}, {
	caption: t('common.fields.quantity'),
	dataField: 'amount',
	calculateDisplayValue: ({ amount, unit }) => {
		const isInteger = unit === '1'
		return isInteger ? amount : NumberCell({ toFixed: 3 })({ value: amount })
	}
}, {
	caption: t('statistic_section.strings.difference'),
	dataField: 'inventoryDifference',
	calculateDisplayValue: ({ inventoryDifference, unit }) => {
		const isInteger = unit === '1'
		return isInteger ? inventoryDifference : NumberCell({ toFixed: 3 })({ value: inventoryDifference })
	}
}]

export const columns_inventoryDetails = ({ isInteger }) => (t) => [{
	caption: t('common.fields.cash_register'),
	dataField: 'cashRegisterName'
}, {
	caption: t('common.fields.name'),
	dataField: 'type',
	calculateDisplayValue: ({ type, parentDirection, parentProduct }) => {
		let out = type
		if(parentDirection && parentProduct) {
			out += ` ${parentDirection}`
		}
		if(parentProduct) {
			out += ` ${parentProduct.name}`
		}
		return out
	}
}, {
	caption: t('common.fields.date'),
	dataField: 'date',
	localFormat: { type: 'date' },
	alignment: 'right'
}, {
	caption: t('product_section.fields.number'),
	dataField: 'number'
}, {
	caption: '+',
	dataField: 'plus',
	width: 80,
	calculateDisplayValue: ({ plus, plusDisplay }) => {
		const displayValue = typeof plusDisplay !== 'undefined' ? plusDisplay : plus
		return isInteger ? displayValue : NumberCell({ toFixed: 3 })({ value: displayValue })
	},
	summary: {
		summaryType: 'sum',
		customizeText: ({ value }) => NumberCell({ toFixed: Number.isInteger(value) ? 0 : 3 })({ value })
	}
}, {
	caption: '-',
	dataField: 'minus',
	width: 80,
	calculateDisplayValue: ({ minus, minusDisplay }) => {
		const displayValue = typeof minusDisplay !== 'undefined' ? minusDisplay : minus
		return isInteger ? displayValue : NumberCell({ toFixed: 3 })({ value: displayValue })
	},
	summary: {
		summaryType: 'sum',
		customizeText: ({ value, ...rest }) => NumberCell({ toFixed: isInteger ? 0 : 3 })({ value })
	}
}]

